import userImg from "./images/defaultUser.png";
import add from "./images/add.svg";
import settings from "./images/settings.svg";
import instagram from "./images/instagram.svg";
import instagramGray from "./images/instagramGray.svg";
import leftArrow from "./images/leftArrow.svg";
import heyhireNewIcon from "./images/heyhireNewIcon.svg";
import heyhireNewBlack from "./images/heyhireNewBlack.svg";

// Only actively used images are exported
export const defaultUserImage = userImg;
export const addIcon = add;
export const settingsIcon = settings;
export const instagramIcon = instagram;
export const instagramGrayIcon = instagramGray;
export const leftArrowImage = leftArrow;
export const heyhireIcon = heyhireNewIcon;
export const heyhireBlackIcon = heyhireNewBlack;
